import Icon from "./Icon";

const PlayIcon = (props) => (
    <Icon viewBox="0 0 20 20" className={props.className} width={props.width} height={props.height}>
        <path d="M5 2.5L16.6667 10L5 17.5V2.5Z" stroke="#00B3C7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </Icon>
);

export default PlayIcon;
